import React, { InputHTMLAttributes, useState, useCallback } from 'react';

import ErrorTooltip from '~/components/Tooltips/Error';

import WarningTooltip from '~/components/Tooltips/Warning';

import { Label, Container, InputText } from './styles';

interface IDynamicCurrencyProps extends InputHTMLAttributes<HTMLInputElement> {
  name?: string;
  labelFor?: string;
  labelText?: string;
  upperCaseLabel?: boolean;
  error?: string;
  warning?: string;
  value: number;
  defaultValue?: number;
  disabled?: boolean;
  onSet?: (e: any) => void;
}

const DynamicCurrency = React.forwardRef<
  HTMLInputElement,
  IDynamicCurrencyProps
>(
  (
    {
      name,
      labelFor,
      labelText,
      upperCaseLabel,
      error,
      warning,
      value,
      defaultValue,
      disabled,
      onSet,
    }: IDynamicCurrencyProps,
    ref,
  ) => {
    const [isFocused, setIsFocused] = useState(false);
    const [manual, setManual] = useState(false);

    const handleInputFocus = useCallback(() => {
      setIsFocused(!isFocused);
    }, [isFocused]);

    const handleInputBlur = useCallback(() => {
      setIsFocused(false);
    }, []);

    const handleChange = (e: any): void => {
      const valueSplit = e.target.value.split(',', 2);

      if (valueSplit[1] && valueSplit[1].length > 2) {
        const decimalExcess = valueSplit[1].length - 2;

        e.target.value = e.target.value.substring(
          0,
          e.target.value.length - decimalExcess,
        );
      }

      if (e.target.value[e.target.value.length - 1] === ',') {
        setManual(true);
      } else {
        setManual(false);
      }

      if (onSet) {
        onSet(e);
      }
    };

    return (
      <>
        {labelText && (
          <Label isFocused={isFocused}>
            {upperCaseLabel ? labelText.toUpperCase() : labelText}
          </Label>
        )}

        <Container id={labelFor} isFocused={isFocused} isErrored={!!error}>
          <InputText
            name={name}
            type="text"
            onFocus={handleInputFocus}
            onBlur={handleInputBlur}
            value={manual ? undefined : value}
            defaultValue={defaultValue}
            ref={ref}
            intlConfig={{ locale: 'pt-BR', currency: 'BRL' }}
            allowNegativeValue={false}
            decimalsLimit={2}
            fixedDecimalLength={2}
            maxLength={9}
            onChange={e => {
              handleChange(e);
            }}
            disabled={disabled}
          />

          {error && <ErrorTooltip title={error} />}

          {warning && <WarningTooltip title={warning} />}
        </Container>
      </>
    );
  },
);

export default DynamicCurrency;
